import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import axios from "../../../axios";
import ITQANDropDown from "../../../libs/components/filter";
import { Editor } from "@tinymce/tinymce-react";
import {
  _getCheckbox,
  _getNormalInput,
  _getPhoneInput,
  _getPhotoInput,
  _getSelectInput,
  InsuranceTypes,
  MessageRequestType,
} from "../../../libs";
import moment from "moment";
import { Button } from "@material-ui/core";
import {
  SendMessageOptions,
  SendMessageOptionsArray,
} from "../../../libs/SendMessageOptions";

export default function SendMessageComponent({
  agenciesDropdownGet,
  agenciesDropdownSet,
  companiesDropdownGet,
  companiesDropdownSet,
  agencyListsDropdownGet,
  agencyListsDropdownSet,
  agencies,
  showMessage,
  setLoading,
  handleAppError,
  lang,
  historyObj,
}) {
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    watch,
  } = useForm({
    defaultValues: {},
  });
  const [state, setState] = useState({
    selectedAgencies: null,
    type: MessageRequestType.Custom,
    sendToWhatsappGroup: false,
    asTest: false,
    adImage: null,
    previewAdImage: null,
    sendImage: false,
  });
  const previewIdImage = (imageFile) => {
    if (imageFile) {
      console.log("image selected ...");
      setState({
        ...state,
        imageLoadProgress: true,
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setState({
          ...state,
          previewAdImage: reader.result,
          adImage: imageFile,
          imageLoadProgress: false,
        });
      };
      reader.readAsDataURL(imageFile);
    }
  };
  const adImageRef = useRef(null);
  const editorRef = useRef(null);
  const watchAgenciesType = watch("agenciestype");
  const validateEntry = (values) => {
    let message = editorRef.current.getContent().replace(/<[^>]*>/g, "");
    if (values.type.value === MessageRequestType.Custom && !message) {
      showMessage({
        type: "warning",
        title: window.sys_app_translate("Message is empty!", lang),
        message: window.sys_app_translate("Please fill in the message", lang),
      });
      return false;
    }
    if (
      values.type.value === MessageRequestType.Custom &&
      (!state.selectedAgencies || state.selectedAgencies.length === 0)
    ) {
      showMessage({
        type: "warning",
        title: window.sys_app_translate("No Selected Agencies!", lang),
        message: window.sys_app_translate("Please Select Agencies", lang),
      });
      return false;
    }
  };
  const onSubmit = async (values) => {
    const { selectedAgencies } = state;
    try {
      setLoading(true);
      if (!validateEntry) {
        return;
      }
      const formData = new FormData();
      formData.append("type", values.type);
      formData.append("date", moment(new Date()).format("YYYY-MM-DD"));

      if (state.type === MessageRequestType.DebtPaymentNotification) {
        if (values.maximumdebt) {
          formData.append("maximumdebt", values.maximumdebt);
        }
        if (values.minimumdebt) {
          formData.append("minimumdebt", values.minimumdebt);
        }
      }
      if (state.type !== MessageRequestType.DebtPaymentNotification) {
        formData.append("agenciestype", values.agenciestype.value);
        switch (values.agenciestype.value) {
          case SendMessageOptions.AllAgencies:
          case SendMessageOptions.AgenciesWhoStoppedWorkingLast7Days:
          case SendMessageOptions.AgenciesWhoStoppedWorkingLast30Days:
          case SendMessageOptions.AgenciesWhoStoppedWorkingLast60Days:
          case SendMessageOptions.AgenciesWithNoInsurances:
          case SendMessageOptions.TopAgencies:
            //do nothinig
            break;
          case SendMessageOptions.SpecificAgencies:
            formData.append("agencies", selectedAgencies.join(","));
            break;
          case SendMessageOptions.AgenciesWhoHasSpecificRatios:
          case SendMessageOptions.AgenciesWithRatioLargerThan:
          case SendMessageOptions.AgenciesWithRatioSmallerThan:
            formData.append("insurancetype", values.insurancetype.value);
            formData.append(
              "insurancecompanyid",
              values.insurancecompanyid.map((item) => item.value)
            );
            formData.append("ratio", values.ratio);
            break;
          case SendMessageOptions.SpecificParentAgency:
            formData.append("parentagencyid", values.parentagencyid.value);
            break;
          case SendMessageOptions.SpecificAgencyList:
            formData.append("agencylistid", values.agencylistid.value);
            break;
        }
        if (values.message) {
          let message = values.message
          formData.append(
            "message",
            message
          );
        }
      }
      formData.append(
        "sendtowhatsappgroup",
        state.sendToWhatsappGroup ? "true" : "false"
      );
      formData.append("astest", state.asTest);
      if (state.sendImage && state.adImage) {
        formData.append("image", state.adImage);
      }
      await axios.post("/message-requests", formData);
      showMessage({
        type: "success",
        title: window.sys_app_translate("Successful Operation!", lang),
        message: window.sys_app_translate(
          "Message request successfully sent!",
          lang
        ),
      });
      historyObj.replace("/app/message-requests/view-all");
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  };
  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-4">
              <div
                className="container-fluid"
                style={{
                  backgroundColor: "white",
                  borderRadius: "25px",
                  padding: "1rem",
                }}
              >
                <>
                  <div className="row my-2">
                    <div className="col-12">
                      <select
                        className="form-select"
                        {...register("type", {
                          required: true,
                          onChange: (e) => {
                            setState({
                              ...state,
                              type: e.target.value,
                            });
                          },
                        })}
                        name="type"
                      >
                        <option value={MessageRequestType.Custom}>
                          {window.sys_app_translate("Custom", lang)}
                        </option>
                        <option
                          value={MessageRequestType.DebtPaymentNotification}
                        >
                          {window.sys_app_translate("Debt Message", lang)}
                        </option>
                      </select>
                      <div className="my-2"></div>
                    </div>
                  </div>
                  {state.type ===
                    MessageRequestType.DebtPaymentNotification && (
                      <>
                        <div className="row my-2 justify-content-center">
                          <div className="col-4 inter inter-medium">
                            <input
                              className="form-control"
                              name="minimumdebt"
                              {...register("minimumdebt", {
                                required: false,
                              })}
                              placeholder={window.sys_app_translate(
                                "Minimum Debt",
                                lang
                              )}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              className="form-control"
                              name="maximumdebt"
                              {...register("maximumdebt", {
                                required: false,
                              })}
                              placeholder={window.sys_app_translate(
                                "Maximum Debt",
                                lang
                              )}
                            />
                          </div>
                        </div>
                        <div className="row my-2">
                          <div className="col-12">
                            <ITQANDropDown
                              placeholder={window.sys_app_translate(
                                "Or choose Agencies",
                                lang
                              )}
                              fullWidth={true}
                              options={agencies}
                              lang={lang}
                              optionsSelected={(selectedAgencies) => {
                                setState({
                                  ...state,
                                  selectedAgencies: selectedAgencies,
                                });
                              }}
                              returnAsArray={true}
                              renderSelectedValues={true}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  {state.type === MessageRequestType.Custom && (
                    <>
                      <div className="row my-2">
                        {_getSelectInput({
                          control: control,
                          inputName: "agenciestype",
                          options: SendMessageOptionsArray.map((item) => {
                            return {
                              label: window.sys_app_translate(item, lang),
                              value: item,
                            };
                          }),
                          errors: errors,
                          inputTitle: "Agencies Type",
                          width: "col-12",
                          lang,
                        })}

                        {watchAgenciesType &&
                          [SendMessageOptions.SpecificAgencies].includes(
                            watchAgenciesType.value
                          ) && (
                            <>
                              <div className="my-2"></div>
                              <div className="col-12">
                                <ITQANDropDown
                                  placeholder={window.sys_app_translate(
                                    "Select Agencies",
                                    lang
                                  )}
                                  fullWidth={true}
                                  options={agencies}
                                  lang={lang}
                                  optionsSelected={(selectedAgencies) => {
                                    setState({
                                      ...state,
                                      selectedAgencies: selectedAgencies,
                                    });
                                  }}
                                  returnAsArray={true}
                                  renderSelectedValues={true}
                                />
                              </div>
                            </>
                          )}

                        {watchAgenciesType &&
                          [SendMessageOptions.SpecificParentAgency].includes(
                            watchAgenciesType.value
                          ) && (
                            <>
                              <div className="my-2"></div>
                              {_getSelectInput({
                                control: control,
                                inputName: "parentagencyid",
                                options: agenciesDropdownGet,
                                errors: errors,
                                inputTitle: "Parent Agency",
                                width: "col-12",
                                lang,
                              })}
                            </>
                          )}

                        {watchAgenciesType &&
                          [
                            SendMessageOptions.AgenciesWhoHasSpecificRatios,
                            SendMessageOptions.AgenciesWithRatioLargerThan,
                            SendMessageOptions.AgenciesWithRatioSmallerThan,
                          ].includes(watchAgenciesType.value) && (
                            <>
                              <div className="my-2"></div>
                              {_getSelectInput({
                                control: control,
                                inputName: "insurancetype",
                                options: InsuranceTypes,
                                multiple: false,
                                errors: errors,
                                inputTitle: "Insurance Type",
                                width: "col-12",
                                lang,
                              })}
                            </>
                          )}

                        {watchAgenciesType &&
                          [
                            SendMessageOptions.AgenciesWhoHasSpecificRatios,
                            SendMessageOptions.AgenciesWithRatioLargerThan,
                            SendMessageOptions.AgenciesWithRatioSmallerThan,
                          ].includes(watchAgenciesType.value) && (
                            <>
                              <div className="my-2"></div>
                              {_getSelectInput({
                                control: control,
                                inputName: "insurancecompanyid",
                                options: companiesDropdownGet,
                                multiple: true,
                                errors: errors,
                                inputTitle: "Insurance Companies",
                                width: "col-12",
                                lang,
                              })}
                            </>
                          )}

                        {watchAgenciesType &&
                          [
                            SendMessageOptions.AgenciesWhoHasSpecificRatios,
                            SendMessageOptions.AgenciesWithRatioLargerThan,
                            SendMessageOptions.AgenciesWithRatioSmallerThan,
                          ].includes(watchAgenciesType.value) && (
                            <>
                              <div className="my-2"></div>
                              {_getNormalInput({
                                control,
                                inputName: "ratio",
                                inputTitle: "Ratio",
                                inputId: "Value",
                                errors,
                                lang,
                                width: "col-12",
                                inputSize: "small",
                                required: true,
                              })}
                            </>
                          )}
                        {watchAgenciesType &&
                          [SendMessageOptions.SpecificAgencyList].includes(
                            watchAgenciesType.value
                          ) && (
                            <>
                              <div className="my-2"></div>
                              {_getSelectInput({
                                control: control,
                                inputName: "agencylistid",
                                options: agencyListsDropdownGet,
                                errors: errors,
                                inputTitle: "Agency List",
                                width: "col-12",
                                lang,
                              })}
                            </>
                          )}
                        <div className="my-2"></div>
                        {_getCheckbox({
                          inputName: "sendtowhatsappgroup",
                          inputTitle: "Send to whatsapp group",
                          inputId: "SendToWhatsappGroup",
                          isChecked: state.sendToWhatsappGroup,
                          style: {
                            display: "flex",
                            alignItems: "center",
                          },
                          onChange: (e) => {
                            setState({
                              ...state,
                              sendToWhatsappGroup: e.target.checked,
                            });
                          },
                          lang: lang,
                          width: "col-12",
                        })}
                        {_getCheckbox({
                          inputName: "astest",
                          inputTitle: "As Test",
                          inputId: "asTest",
                          isChecked: state.asTest,
                          style: {
                            display: "flex",
                            alignItems: "center",
                          },
                          onChange: (e) => {
                            setState({ ...state, asTest: e.target.checked });
                          },
                          lang: lang,
                          width: "col-12",
                        })}
                      </div>
                    </>
                  )}
                  <div className="row my-2">
                    <div className="col-12">
                      <Button
                        variant="contained"
                        style={{ width: "100%" }}
                        className="inter inter-bold"
                        type="submit"
                      >
                        {window.sys_app_translate("Send", lang)}
                      </Button>
                    </div>
                  </div>
                </>
              </div>
            </div>
            <div className="col-4">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    {_getNormalInput({
                      control,
                      inputName: "message",
                      inputTitle: "Message",
                      inputId: "Message",
                      errors,
                      lang,
                      width: "col-12",
                      inputSize: "small",
                      required: true,
                      type: "textarea",
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="container-fluid">
                <div className="row">
                  {_getCheckbox({
                    inputName: "sendimage",
                    inputTitle: "Send Image",
                    inputId: "SendImage",
                    isChecked: state.sendImage,
                    style: {
                      display: "flex",
                      alignItems: "center",
                    },
                    onChange: (e) => {
                      setState({ ...state, sendImage: e.target.checked });
                    },
                    lang: lang,
                    width: "col-12",
                  })}
                  {_getPhotoInput({
                    previewImage: state.previewAdImage,
                    uploadFileInputRef: adImageRef,
                    inputName: "messageimage",
                    inputTitle: "",
                    lang,
                    previewIdImage: previewIdImage,
                    errors: errors,
                    width: "col-12",
                    imageWidth: "100%",
                    imageHeight: "25rem",
                    inputDesc: "",
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
}
